import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout } from "@pimo/pimo-components/src/lib/layouts/drag-and-drop-layout/drag-and-drop-layout";
import { PMDonutChartCard } from "@pimo/pimo-components/src/lib/pm-components";

import { TestAppState } from "../../../app";
import { getDropdownCount } from "../../../utils/dropdown-options";
import { getLocalizedCardCopy } from "../../../utils/get-localized-card-copy";
import {
  getItemName,
  getPluralOfItemName,
} from "../../../utils/get-plural-of-item-name";
import { getOverviewCardCopy } from "../get-card-copy";

export function addStatusOfItemsAndTrackingCompletionCards(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
): void {
  const { language, projectName, projectNamePlural, getCardCopy } =
    getOverviewCardCopy(app);

  const statusOfItemsComponent = view.addComponent({
    component: PMDonutChartCard,
    layoutProps: {
      componentId: "statusOfItemsComponent",
      title: "",
      description: "",
      labels: ["donutChart", "chart", "status"],
    },
  });

  statusOfItemsComponent.mapLayoutProps(({ language }) => {
    return {
      componentId: "statusOfItemsComponent",
      labels: ["donutChart", "chart", "status"],
      description: getCardCopy(language, "statusOfItems").description,
      title: getCardCopy(language, "statusOfItems").title,
    };
  });
  statusOfItemsComponent.mapState(({ dashboard, settings, language }) => {
    const statusCounts = dashboard?._calculated?.statusCounts ?? {};
    const data = (settings?.configuration?.statusDefinition ?? []).map(
      (entry) => {
        return {
          label: entry.name ?? "",
          value: getDropdownCount(statusCounts, entry),
          color: entry.color ?? "",
        };
      }
    );

    return {
      title: getLocalizedCardCopy(language, "statusOfItems", {
        itemName: getItemName(settings?.configuration?.itemName, language),
        itemNamePlural: getPluralOfItemName(
          settings?.configuration?.itemName,
          language
        ),
        projectName,
        projectNamePlural,
      }).title,
      icon: "DonutLarge",
      data,
    };
  });

  statusOfItemsComponent.mapVisibility(({ settings }) => {
    return (
      (settings?.configuration?.statusReportingLevel ?? "overall") === "overall"
    );
  });

  const completionOfTrackingItemsComponent = view.addComponent({
    component: PMDonutChartCard,
    layoutProps: {
      componentId: "completionOfTrackingItemsComponent",
      labels: ["donutChart", "chart", "status"],
      description: getCardCopy(language, "completionOfItems").description,
      title: getCardCopy(language, "completionOfItems").title,
    },
  });

  completionOfTrackingItemsComponent.mapLayoutProps(({ language }) => {
    return {
      componentId: "completionOfTrackingItemsComponent",
      labels: ["donutChart", "chart", "status"],
      title: getCardCopy(language, "completionOfItems").title,
      description: getCardCopy(language, "completionOfItems").description,
    };
  });

  completionOfTrackingItemsComponent.mapState(
    ({ dashboard, settings, language }) => {
      const degreeOfCompletionCounts =
        dashboard?._calculated?.degreeOfCompletionCounts ?? {};

      const data = (
        settings?.configuration?.degreeOfCompletionDefinition ?? []
      ).map((entry) => {
        return {
          label: entry.name ?? "",
          value: getDropdownCount(degreeOfCompletionCounts, entry),
          color: entry.color ?? "",
        };
      });

      return {
        title: getLocalizedCardCopy(language, "completionOfItems", {
          itemName: getItemName(settings?.configuration?.itemName, language),
          itemNamePlural: getPluralOfItemName(
            settings?.configuration?.itemName,
            language
          ),
          projectName,
          projectNamePlural,
        }).title,
        icon: "DonutLarge",
        data,
      };
    }
  );
}
